import * as React from 'react';
import { Dispatch } from 'redux';
import { CreateUserViewModel } from 'stageclip-common';

import { BaseApiPatchRequest } from '../generic/baseApiPatchRequest';
import * as EntityNormalizers from '../normalizers/entityNormalizers';
import * as UserNormalizers from '../normalizers/userNormalizers';

export class EditUserRequest extends BaseApiPatchRequest<
  CreateUserViewModel,
  EntityNormalizers.NormalizedSingleEntity<UserNormalizers.NormalizedUsers>
> {
  constructor(userId: string, formData: CreateUserViewModel, component: React.Component, dispatch: Dispatch) {
    super(formData, component, dispatch);
    this.path = `/users/${userId}`;
    this.normalizeMethod = UserNormalizers.normalizeSingleUser;
  }
}
